var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoSwaps = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#no-swaps_svg__a)"
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#EBF2EF"
})), /*#__PURE__*/React.createElement("mask", {
  id: "no-swaps_svg__b",
  width: 120,
  height: 120,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C6365B",
  d: "M120 57.33C120 87.224 88.12 120 60.089 120 32.057 120 0 87.225 0 57.33 0 30.288 29.197 0 59.84 0c7.2 0 13.395 0 15.226 1.155C93.249 11.603 120 35.022 120 57.33Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#no-swaps_svg__c)",
  mask: "url(#no-swaps_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M60.854 94.523H40.787l1.527 27.165h17.123l.708-13.582.71-13.583Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#86B09B",
  d: "M79.328 69.374c-8.166 5.883-15.852 2.254-18.675-.295 1.761-2.72 18.653-11.871 26.878-16.107 1.92 8.962-4.669 14.67-8.203 16.402Z",
  opacity: 0.35
}), /*#__PURE__*/React.createElement("path", {
  fill: "#86B09B",
  d: "M40.537 77.33c-9.006-4.49-9.37-12.983-8.427-16.667 3.227.293 19.186 10.988 26.763 16.299-7.04 5.868-15.158 2.691-18.336.369ZM59.95 42.402c1.358-6.754.184-23.58-.573-31.15-6.567 1.74-9.195 10.813-9.688 15.132-.634 8.918 6.577 14.395 10.262 16.018Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#86B09B",
  d: "M53.543 95.248H40.877l2.79 26.405h9.876V95.248Z",
  opacity: 0.35
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.664,
  d: "M38.124 94.533v-4.826h43.932v4.826H38.124ZM40.621 94.533l2.58 27.624h33.947l2.58-27.624M49.621 27.3c-.54-8.665 6.238-14.592 9.696-16.472 9.2 5.054 10.341 13.312 10.341 16.471-1.082 10.108-6.433 14.44-9.214 15.343-8.838-2.888-10.898-11.432-10.823-15.343ZM68.97 52.24c7.278-4.733 15.775-1.742 19.113.345.128 10.5-6.263 15.977-9.013 17.531-9.333 4.03-15.976 1.079-18.13-.9-1.836-9.121 4.589-15.118 8.03-16.976ZM50.793 60.236c7.422 4.502 8.415 13.455 7.984 17.369-9.405 4.672-17.113 1.292-19.706-.512-7.68-6.66-7.905-13.924-7.058-16.724 7.42-5.613 15.612-2.427 18.78-.133ZM40.851 64.961l16.509 11.76M61.715 68.093l17.088-9.866M60.194 42.306l-.192-19.73"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeWidth: 1.664,
  d: "M60.114 42.643v46.252"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "no-swaps_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h120v120H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "no-swaps_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M30.469 0h58.743v123.371H30.469z"
})))));
export default SvgNoSwaps;